// extracted by mini-css-extract-plugin
module.exports = {"blend":"BlendingLogo_blend__a4SxV"};